//require('jquery');
import $ from "jquery";
window.$ = $;
window.jQuery = $;
require("slick-carousel");

/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

/* jshint ignore:start */
window.getCookie = function (name) {
  let match = document.cookie.match(new RegExp(name + "=([^;]+)"));
  if (match) {
    return match[1];
  }
};

require("./patient-assessment.js");
//require('./patient-assessment-de.js');
require("./newsletter-signup");
require("./qrcode-signup.js");
require("./video");
require("./input-mask");
require("./infobox");
require("./regions");
require("./location");
require("./webinar");
require("./physician-finder");
require("./utils/blur_hash");

require("./components/accordion");
require("./components/carousel-callout");
require("./components/downloads");
require("./components/video-placeholder");

(function ($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    common: {
      init: function () {
        // JavaScript to be fired on all pages

        function uuid() {
          var uuid = "",
            i,
            random;
          for (i = 0; i < 32; i++) {
            random = (Math.random() * 16) | 0;

            if (i === 8 || i === 12 || i === 16 || i === 20) {
              uuid += "-";
            }
            uuid += (
              i === 12 ? 4 : i === 16 ? (random & 3) | 8 : random
            ).toString(16);
          }
          return uuid;
        }

        function createCookie(name, value, days) {
          // Cookie setter function
          var expires = "";
          if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = "; expires=" + date.toGMTString();
          } else {
            expires = "";
          }
          document.cookie = name + "=" + value + expires + "; path=/";
        }

        // Generate and set visitorUUID cookie with expiry after 7 days
        var uuidCookie = window.getCookie("visitorUUID");
        if (typeof uuidCookie === "undefined" || uuidCookie.length < 1) {
          createCookie("visitorUUID", uuid(), 7);
        }

        window.regions.setup();

        $(".js-cookie-notification--accept").on("click", function () {
          $(".js-cookie-notification").slideUp();
          createCookie("cookie_notification_accepted", 1, 7);
        });
        //
        // $('.c-header--region-link').click(function(e){
        // 	e.preventDefault();
        //    var $region_link = $(this).data('region-link');
        //    console.log($region_link);
        // 	$('.c-region-popup--button').attr('data-href', $region_link);
        // 	var instance = lity( '#region-redirect', {
        //        'template' : '<div class="lity" role="dialog" tabindex="-1"><div class="lity-wrap" role="document"><div class="lity-loader" aria-hidden="true">Loading...</div><div class="lity-container"><div class="lity-content"></div></div></div></div>',
        //        'esc' : false,
        //    });
        // })
        // $('.j-region-leave').click(function(e){
        //    e.preventDefault();
        //    var $region_id = $(this).data('region-id');
        //    createCookie("allow_region__" + $region_id, 1);
        //    window.location.href = $(this).data('href');
        // });
        // $('.region-stay').click(function(e){
        //    var $region_id = $(this).data('region-id');
        //    console.log($region_id);
        // 	createCookie("allow_region__" + $region_id, 1);
        // 	// document.cookie = 'allow_region=1';
        // 	$('.lity-close').trigger('click');
        // });

        // JavaScript for setting up categories
        $(".c-categories__pill-has-child").on("click", function (e) {
          e.preventDefault();
          $this = $(this);
          $(".c-sub-categories__pill").hide();
          $(
            ".c-sub-categories__pill[data-parent-category-id=" +
              $this.data("category-id") +
              "]"
          ).show();
        });

        $(".c-categories__mobile-callout").on("click", function (e) {
          e.preventDefault();
          $("body").toggleClass("c-categories--active");
        });

        $(".j-tags").on("click", function (e) {
          //e.preventDeafult();
          const tag = $(this).data("tag-id");
          if (tag == 0) {
            $(".c-learn--list").show();
          } else {
            $(".c-learn--list").hide();
            $(".c-learn--list.tag--" + tag).show();
          }
        });

        $(".js-cookie-notification--accept").on("click", function () {
          $(".js-cookie-notification").slideUp();
          createCookie("cookie_notification_accepted", 1, 7);
        });

        var twitterShare = document.querySelector('[data-js="twitter-share"]');
        if (twitterShare) {
          twitterShare.onclick = function (e) {
            e.preventDefault();
            console.log(document.URL);
            var twitterWindow = window.open(
              "https://twitter.com/share?url=" + document.URL,
              "twitter-popup",
              "height=350,width=600"
            );
            if (twitterWindow.focus) {
              twitterWindow.focus();
            }
            return false;
          };
        }

        var facebookShare = document.querySelector(
          '[data-js="facebook-share"]'
        );
        if (facebookShare) {
          facebookShare.onclick = function (e) {
            e.preventDefault();
            console.log(document.URL);
            var facebookWindow = window.open(
              "https://www.facebook.com/sharer/sharer.php?u=" + document.URL,
              "facebook-popup",
              "height=350,width=600"
            );
            if (facebookWindow.focus) {
              facebookWindow.focus();
            }
            return false;
          };
        }

        // List of Video Vendors embeds you want to support
        var players = [
          'iframe[src*="youtube.com"]',
          'iframe[src*="vimeo.com"]',
        ];

        // Select videos
        var fitVids = document.querySelectorAll(players.join(","));

        // If there are videos on the page...
        if (fitVids && fitVids.length) {
          // Loop through videos
          for (var i = 0; i < fitVids.length; i++) {
            // Get Video Information
            var fitVid = fitVids[i];
            var width = fitVid.getAttribute("width");
            var height = fitVid.getAttribute("height");
            var aspectRatio = height / width;
            var parentDiv = fitVid.parentNode;

            // Wrap it in a DIV
            var div = document.createElement("div");
            div.className = "fitVids-wrapper";
            div.style.paddingBottom = aspectRatio * 100 + "%";
            parentDiv.insertBefore(div, fitVid);
            fitVid.remove();
            div.appendChild(fitVid);

            // Clear height/width from fitVid
            fitVid.removeAttribute("height");
            fitVid.removeAttribute("width");
          }
        }
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

        // No scroll on popups
        $("body").on("touchmove", ".lity-opened", function (e) {
          //e.preventDefault();
          e.stopPropagation();
          //return false; //
        });

        // STICKY HEADER

        var header = $(".header");
        const body = $("body");

        // Header Toggle
        header
          .on("click", ".header--toggle", function () {
            if (body.hasClass("header__menu-open")) {
              body.removeClass("header__menu-open");
            } else {
              body.addClass("header__menu-open");
            }
          })
          .on("click", ".menu-child-toggle", function () {
            $(this).parent().toggleClass("menu-open");
          });

        // CALLOUT CLOSE
        $(".j-header-callout--close").on("click", function () {
          $(".j-header-callout").slideUp();
        });

        // VIDEO PLAYLIST
        var video_playlist = $(".c-video-playlist");
        video_playlist.on("click", ".c-video-playlist--video", function (e) {
          e.preventDefault();
          var _this = $(this);
          if (!_this.hasClass("active")) {
            var video = _this.data("id");
            var parent = _this.parents(".c-video-playlist");
            $(".c-video-playlist--video").removeClass("active");
            _this.addClass("active");
            parent
              .find(".c-video-playlist--player__" + video)
              .addClass("active")
              .siblings()
              .removeClass("active");

            parent.find(".c-video--player").each(function () {
              var current = jQuery(this);
              var current_id = current.data("video-id");
              if (typeof window.videoPlayers[current_id] !== "undefined") {
                if (
                  typeof window.videoPlayers[current_id].pauseVideo ===
                  "function"
                ) {
                  window.videoPlayers[current_id].pauseVideo();
                }
              }
            });
          }
        });

        // Build playlist language selector
        var langs = [];
        var videoLanguageSelector = $("#video-language-selector");
        video_playlist
          .find(".c-video-playlist--video, .c-video-playlist--player")
          .each(function () {
            var lang = $(this).data("lang");
            if (!langs.includes(lang)) {
              videoLanguageSelector.append(new Option(lang, lang));
              langs.push(lang);
            }
          });
        videoLanguageSelector.on("change", function () {
          changeVideoLanguage($(this).children("option:selected").val());
        });
        const changeVideoLanguage = function (lang) {
          // cleanup langagues NOT matching this selection
          video_playlist
            .find(".c-video-playlist--video, .c-video-playlist--player")
            .each(function () {
              if ($(this).data("lang") != lang) {
                $(this).hide();
              } else {
                $(this).css("display", "");
              }
            });

          // simulate click on first element
          video_playlist.find(".c-video-playlist--video:visible:first").click();
        };
        changeVideoLanguage(langs[0]);

        // if there is only one language, don't borth showing an languague selector
        if (langs.length <= 1) {
          $("#video-languages").hide();
        }

        // Build GROUPED playlist language selector
        if($('.c-grouped-video-playlist--languages')) {
            var langs = [];
            var videoLanguageSelector = $('#video-language-selector');
            const video_playlist = $('.c-grouped-video-playlist--languages');
            // video_playlist.find('.c-grouped-video-playlist').each(function() {
            //     var lang = $(this).data('lang');
            //     if(!langs.includes(lang)) {
            //         videoLanguageSelector.append(new Option(lang, lang));
            //         langs.push(lang);
            //     }
            // });
            videoLanguageSelector.on('change', function() {
                //e.preventDefault();
                changeVideoLanguage2($(this).children("option:selected").val());
            });
            const changeVideoLanguage2 = function(lang) {
                // cleanup languages NOT matching this selection
                video_playlist.find('.c-grouped-video-playlist').each(function() {
                    if($(this).data('lang') != lang) {
                        $(this).addClass('hidden');
                    } else {
                        $(this).removeClass('hidden');
                    }
                });

                // simulate click on first element
                //video_playlist.find('.js-play-video:visible:first').click();
            }
            //changeVideoLanguage2(langs[0]);

            // if there is only one language, don't borth showing an languague selector
            if(langs.length <= 1) {
                $('#video-languages').hide();
            }

        }

        // FAQ TOGGLE
        var singleOpen = true;
        $(".c-faq").on("click", ".j-faq--toggle", function (e) {
          e.preventDefault();
          var _this = $(this);
          //  Close other tabs (if set to)
          if (singleOpen) {
            _this.closest(".c-faq--row").siblings().removeClass("opened");
          }
          // Toggle this tab
          _this.closest(".c-faq--row").toggleClass("opened");
        });

        // FAQ TOGGLE
        var singleOpen = true;
        $(".c-safetyfaq").on("click", ".j-faq--toggle", function (e) {
          e.preventDefault();
          var _this = $(this);
          //  Close other tabs (if set to)
          if (singleOpen) {
            _this.parent().siblings().removeClass("opened");
          }
          // Toggle this tab
          _this.parent().toggleClass("opened");
        });

        // SIMPLE FAQ TOGGLE
        $(".simple-faq").on("click", ".faq--toggle", function (e) {
          e.preventDefault();
          console.log("opening: ", this);
          var _this = $(this);
          //  Close other tabs (if set to)
          _this.closest(".faq--row").siblings().removeClass("opened");
          // Toggle this tab
          _this.closest(".faq--row").toggleClass("opened");
        });

        // VIDEO  BANNER AUTOPLAY
        if (
          window.location.hash &&
          window.location.hash === "#introduction-video"
        ) {
          $(".c-banner--video-play.s-play-icon").click();
        }


        // carousel //
        /*
                var videoPlaylistBreakpoint = 1200;
                function slickify() {
                    var image_carousel = $('.c-video-playlist--image__carousel');
                    var list_carousel = $('.c-video-playlist--list__carousel');

                    if (!image_carousel.hasClass('slick-initialized')) {
                        $('.c-video-playlist--image__carousel').slick({
                            mobileFirst: true,
                            draggable: false,
                            asNavFor: '.c-video-playlist--list__carousel',
                            arrows: false,
                            dots: false,
                            responsive: [{
                                breakpoint: videoPlaylistBreakpoint,
                                settings: "unslick"
                            }]
                        });
                    }
                    if (!list_carousel.hasClass('slick-initialized')) {
                        $('.c-video-playlist--list__carousel').slick({
                            mobileFirst: true,
                            dots: true,
                            nextArrow: '<i class="icon-arrow-right slick-next"></i>',
                            prevArrow: '<i class="icon-arrow-left slick-prev"></i>',
                            asNavFor: '.c-video-playlist--image__carousel',
                            responsive: [{
                                breakpoint: videoPlaylistBreakpoint,
                                settings: "unslick"
                            }]
                        }).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                            $('.c-video-playlist').find('.c-video--player').each(function() {
                                var current = jQuery(this);
                                var current_id = current.data('video-id');
                                if (typeof window.videoPlayers[current_id] !== "undefined") {
                                    if (typeof window.videoPlayers[current_id].pauseVideo === 'function') {
                                        window.videoPlayers[current_id].pauseVideo();
                                    }
                                }
                            });
                        });
                    }

                }

                slickify();
                $(window).resize(function() {
                    var $windowWidth = $(window).width();
                    if ($windowWidth < videoPlaylistBreakpoint) {
                        slickify();
                    }
                });
                */

        // Simple Slick slider (finally)
        $(".slick").slick({
          mobileFirst: true,
          draggable: true,
          //asNavFor: '.c-video-playlist--list__carousel',
          arrows: true,
          dots: true,
        });

        // Submit Story Form
        var story_form = $("#gform_fields_2");
        if (story_form.length > 0) {
          story_form.find("#choice_2_6_1").prop("disabled", "disabled");
          if (story_form.find("#input_2_13").val() === "true") {
            story_form.find("#choice_2_6_1").prop("disabled", false);
          }
          $("#field_2_9").on("scroll", function () {
            if (
              $(this).scrollTop() + $(this).innerHeight() >=
              $(this)[0].scrollHeight
            ) {
              story_form.find("#choice_2_6_1").prop("disabled", false);
              story_form.find("#input_2_13").val("true");
            }
          });
        }

        $(document).on("lity:open", function (event, instance) {
          $.lockBody();
        });
        $(document).on("lity:close", function (event, instance) {
          $.unlockBody();
        });

        var $docEl = $("html, body"),
          scrollTop;

        $.lockBody = function () {
          if (window.pageYOffset) {
            scrollTop = window.pageYOffset;
          }

          // $docEl.css({
          //     height: "100%",
          //     overflow: "hidden"
          // });
        };
        $.unlockBody = function () {
          // $docEl.css({
          //     height: "",
          //     overflow: ""
          // });
          window.scrollTo(0, scrollTop);
          window.setTimeout(function () {
            scrollTop = null;
          }, 0);
        };

        /// REGION DROP DOWN IN FOOTER
        var regionMenu = $(".j-region-menu");
        regionMenu.on("click", ".j-region-menu--toggle", function () {
          regionMenu.toggleClass("j-region-menu__open");
          if ($(window).width() < 769) {
            setTimeout(function () {
              var height = $(document).height() - $(window).height();
              $("html, body").scrollTop(height);
            }, 500);
          }
        });

        // Footer Observer
        var observer = new IntersectionObserver(
          function (entries) {
            // isIntersecting is true when element and viewport are overlapping
            // isIntersecting is false when element and viewport don't overlap
            var body = $("body");

            if (entries[0].isIntersecting === true) {
              if (!body.hasClass("footer-visible")) {
                body.addClass("footer-visible");
              }
            } else {
              if (body.hasClass("footer-visible")) {
                body.removeClass("footer-visible");
              }
            }
          },
          { threshold: [0] }
        );

        observer.observe(document.querySelector("footer.c-footer"));
      },
    },
    // Home page
    page_template_template_stories: {
      init: function () {
        // JavaScript to be fired on the home page
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS

        // Story Pagination
        var story_container = $(".c-stories--container");
        var story_button = $(".j-loadmore-stories");
        story_button.on("click", function (e) {
          e.preventDefault();
          story_container
            .find(".c-stories--hidden:lt(3)")
            .removeClass("c-stories--hidden");
          var hidden = story_container.find(".c-stories--hidden");
          if (hidden.length < 1) {
            story_button.addClass("c-stories--hidden");
          }
        });
      },
    },
    page_template_template_au_assessment_infographic: {
      finalize: function () {
        // these buttons are not in anymore
        /*
                $('.js-youtube-launch').on('click', function() {
                    $('#au-video').show();
                })
                $('#au-video button').on('click', function() {
                    $('#au-video').hide();
                });
                */
        const assessmentNag = $("#assessment-nag");

        var myScrollFunc = function () {
          var y = window.scrollY;
          if (y >= 800) {
            assessmentNag.addClass("assessment-nag--open");
            //assessmentNag.css({'right': '0'});
            window.removeEventListener("scroll", myScrollFunc);
          } else {
            assessmentNag.removeClass("assessment-nag--open");
          }
        };

        $("#assessment-nag__close").on("click", function (event) {
          event.preventDefault();
          assessmentNag.removeClass("assessment-nag--open");
        });

        window.addEventListener("scroll", myScrollFunc);

        //$('#assessment-nag').css({'right': '0'});
      },
    },
    // About us page, note the change from about-us to about_us.
    blog: {
      init: function () {
        // JavaScript to be fired on the about us page
        window.pagination.setup();
      },
    },
    // About us page, note the change from about-us to about_us.
    tax_press_type: {
      init: function () {
        // JavaScript to be fired on the about us page
        window.pagination.setup();
      },
    },
    // Learn section
    learn: {
      init: function () {},
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = funcname === undefined ? "init" : funcname;
      fire = func !== "";
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === "function";

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire("common");

      // Fire page-specific init JS, and then finalize JS
      $.each(
        document.body.className.replace(/-/g, "_").split(/\s+/),
        function (i, classnm) {
          UTIL.fire(classnm);
          UTIL.fire(classnm, "finalize");
        }
      );

      // Fire common finalize JS
      UTIL.fire("common", "finalize");
    },
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
